import { render, staticRenderFns } from "./WidgetComponent.vue?vue&type=template&id=30e3ad5f&scoped=true&"
import script from "./WidgetComponent.vue?vue&type=script&lang=js&"
export * from "./WidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e3ad5f",
  null
  
)

export default component.exports